import React, {Component} from 'react';
import Icons from '../../components/Icons';
import './Contact.css';
import * as social from './social.json';

export default class Contact extends Component {

  componentDidMount() {
    this.props.setPage("contact");
  }

  render() {
    return (
      <div className="contact">
        <h1>Contact</h1>
        <Icons source={social} direction="left"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Contact/Contact.js